/** Versão em localStorage + evento para actualizar a app do cliente quando o admin altera conteúdo/visibilidade. */

import { getTenantSlug } from '@/config/tenant'

export const CONTEUDO_UPDATED_EVENT = 'agendamentos-app:conteudo-updated'
const CONTEUDO_VERSION_KEY = 'agendamentos-app:conteudo-version'

function snapshotStorageKey(): string {
  const slug = getTenantSlug() || '_'
  return `agendamentos-app:conteudo-snapshot:${slug}`
}

/** Último conteúdo conhecido (evita piscar itens ao ocultar antes do GET). */
export function readConteudoSnapshot(): Record<string, string | null> {
  try {
    const raw = localStorage.getItem(snapshotStorageKey())
    if (!raw) return {}
    const parsed = JSON.parse(raw) as Record<string, string | null>
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export function mergeConteudoSnapshot(partial: Record<string, string | null>): void {
  if (!partial || Object.keys(partial).length === 0) return
  try {
    const prev = readConteudoSnapshot()
    localStorage.setItem(snapshotStorageKey(), JSON.stringify({ ...prev, ...partial }))
  } catch {
    /* ignore */
  }
}

let notifyTimer: ReturnType<typeof setTimeout> | null = null

function dispatchConteudoUpdated(): void {
  try {
    localStorage.setItem(CONTEUDO_VERSION_KEY, String(Date.now()))
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(CONTEUDO_UPDATED_EVENT))
}

/**
 * Chamar após guardar conteúdo no admin.
 * `snapshot` aplica flags na hora nos outros separadores (sem esperar pelo GET).
 * O evento é debounced para um único reload quando há vários PUT seguidos.
 */
export function notifyConteudoUpdated(snapshot?: Record<string, string | null>): void {
  if (snapshot) mergeConteudoSnapshot(snapshot)

  if (notifyTimer) clearTimeout(notifyTimer)
  notifyTimer = setTimeout(() => {
    notifyTimer = null
    dispatchConteudoUpdated()
  }, 100)
}

/** Reexecuta o callback quando o conteúdo do tenant é actualizado no admin. */
export function subscribeConteudoUpdated(listener: () => void): () => void {
  const onStorage = (e: StorageEvent) => {
    if (e.key === CONTEUDO_VERSION_KEY) listener()
  }
  const onCustom = () => listener()
  window.addEventListener('storage', onStorage)
  window.addEventListener(CONTEUDO_UPDATED_EVENT, onCustom)
  return () => {
    window.removeEventListener('storage', onStorage)
    window.removeEventListener(CONTEUDO_UPDATED_EVENT, onCustom)
  }
}
